import Airtable from 'airtable'

export const airtable = new Airtable({ apiKey: 'keyua1duEnwOqpq04' }).base('appqvwKM8oS4vXMii')
export const airtable2 = new Airtable({ apiKey: 'keyua1duEnwOqpq04' }).base('appnACGxkN30JVLrp')

export default airtable
